import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面走丢了 - 深夜吃瓜",
    description:
      "你访问的页面不存在或已被移除。返回深夜吃瓜首页，或去话题广场看看此刻正在被讨论的热话题。",
    keywords: "深夜吃瓜,页面不存在,话题广场",
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex max-w-content flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="brand-font text-6xl text-primary-500 md:text-8xl">404</span>
        <h1 className="heading-serif mt-6 text-2xl font-black text-foreground-950 md:text-3xl">
          这个瓜没找到，可能已经被撤下了
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的页面不存在或已经被移除。不如回首页，看看今晚大家都在聊什么。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500"
          >
            <i className="ri-layout-grid-line" />
            去话题广场
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}